import React from 'react';
import { howSteps } from '../mock';
import { CheckCircle2 } from 'lucide-react';

const HowItWorks = () => {
  return (
    <section id="how-it-works" className="py-14 sm:py-20 lg:py-24 bg-[#3D2817] relative overflow-hidden">
      <div
        className="absolute inset-0 opacity-[0.05] pointer-events-none"
        style={{
          backgroundImage: 'linear-gradient(#F4C430 1px, transparent 1px), linear-gradient(90deg, #F4C430 1px, transparent 1px)',
          backgroundSize: '50px 50px',
        }}
      />

      <div className="max-w-7xl mx-auto px-4 sm:px-5 lg:px-8 relative">
        <div className="grid lg:grid-cols-2 gap-10 sm:gap-14 items-start">
          <div>
            <p className="text-[#F4C430] text-[10px] sm:text-xs tracking-[0.3em] sm:tracking-[0.35em] uppercase">How It Works</p>
            <h2 className="mt-3 font-serif text-3xl sm:text-4xl lg:text-5xl text-[#F5EDE0] leading-tight">
              Four small steps to a sharper mind
            </h2>
            <p className="mt-3 sm:mt-4 text-[#D9C9B3] text-base sm:text-lg max-w-md">
              Whether you are nine or ninety, the flow is the same — quick, playful and quietly effective
            </p>
            <div className="mt-6 sm:mt-8 space-y-3">
              {[
                'Zero setup — start in under 30 seconds',
                'Puzzles adapt to your level automatically',
                'Progress is saved forever, even on the free plan',
              ].map((t) => (
                <div key={t} className="flex items-start gap-3 text-[#E8DCC8] text-sm sm:text-base">
                  <CheckCircle2 className="text-[#F4C430] mt-0.5 shrink-0" size={18} /> <span>{t}</span>
                </div>
              ))}
            </div>
          </div>

          <ol className="relative space-y-4 sm:space-y-6">
            <div className="absolute left-6 top-2 bottom-2 w-px bg-[#5a3d24]" />
            {howSteps.map((s) => (
              <li key={s.step} className="relative pl-16">
                <div className="absolute left-0 top-0 h-12 w-12 rounded-full grid place-items-center bg-[#2A1810] border-2 border-[#F4C430] text-[#F4C430] font-serif text-lg">
                  {s.step}
                </div>
                <div className="rounded-2xl bg-[#2A1810]/60 border border-[#5a3d24] p-5 sm:p-6 hover:border-[#F4C430]/50 transition-colors">
                  <h3 className="font-serif text-xl sm:text-2xl text-[#F5EDE0]">{s.title}</h3>
                  <p className="mt-1.5 sm:mt-2 text-[#B8A990] text-sm sm:text-base">{s.desc}</p>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
